export enum PasswordActions {
  password_change = 'change',
  password_forgot = 'forgot',
  token_expired = 'token-expired',
  login = 'login'
}
